import { render, staticRenderFns } from "./OtherSetting.vue?vue&type=template&id=dd54a73e&scoped=true"
import script from "./OtherSetting.vue?vue&type=script&lang=ts"
export * from "./OtherSetting.vue?vue&type=script&lang=ts"
import style0 from "./OtherSetting.vue?vue&type=style&index=0&id=dd54a73e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd54a73e",
  null
  
)

export default component.exports